import { useContext } from 'react';

import { SidebarCollapseContext } from './sidebarCollapseContextValue';

export function useSidebarCollapse() {
  const context = useContext(SidebarCollapseContext);
  if (context === undefined) {
    throw new Error(
      'useSidebarCollapse must be used within a SidebarCollapseProvider'
    );
  }
  return context;
}
